<button (click)="navigatorTo()" class="feature-btn btn" [style.backgroundColor]="getBackgroundColor()">
  <div class="button-card">
    <app-svg-icon [name]="iconName"></app-svg-icon>
  </div>
  <h5 class="text-gray-800">{{ title }}</h5>
</button>
